import styled from 'styled-components';

export const StyledContent = styled.div(({ theme }) =>
  theme.withMedia({
    padding: '16px 20px 0 20px'
  })
);
